<div class="card">

  <div class="card-content">
    <div class="card-body">
      <ng-content></ng-content>
    </div>
  </div>

</div>
